import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

/**
 * Anime une cible (sélecteur ou élément) à l'entrée dans le viewport.
 * Réutilisable sur n'importe quelle section.
 *
 * @param {string|Element} target        sélecteur CSS ou élément DOM
 * @param {object} animationProps        propriétés gsap.to (ex: { y: 0, opacity: 1 })
 * @param {object} [scrollProps]         surcharge du ScrollTrigger (ex: { start: 'top 80%' })
 */
export const animateWithGsap = (target, animationProps, scrollProps) => {
  gsap.to(target, {
    duration: 1,
    ease: "power2.out",
    ...animationProps,
    scrollTrigger: {
      trigger: target,
      toggleActions: "play none none reverse",
      start: "top 85%",
      ...scrollProps,
    },
  });
};
